/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  FormHelperText,
  Grid,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
  CircularProgress
} from '@material-ui/core'
import ViewHeader from 'components/ViewHeader'
import { useDispatch, useSelector } from 'react-redux'
import ProgressButton from 'components/ProgressButton'
import { useHistory, useParams } from 'react-router-dom'
import { addSession, fetchSessionById, resetSessionStore, updateSessionById } from 'store/session'
import CustomBox from 'components/Form/CustomBox'
import { getCardColors, getConfEvents } from 'store/event'
import { Form, Formik } from 'formik'
import CustomTextField from 'components/Form/CustomTextField'
import CustomDateTimePicker from 'components/CustomDateTimePicker'
import SingleAutocomplete from 'components/SingleAutocomplete'
import { resetEventStore } from 'store/event'
import { sessionFromSchema } from 'schemas/session'
import moment from 'moment-timezone'
import { getDefaultTimezone } from 'utils/times'
import { getConfBuildings } from 'store/building'
import { colors, getContrastColor } from 'utils/colors'
import { getModeratorsAndPresenters } from 'store/speaker'
import { alreadyUsedPoll, pollAttachOrDetach } from 'store/polling'
import { toast } from 'utils/notify'
import { AssociatedPollMsg, Collection, SpeakerRoles } from 'constants/index'
import TextField from '@material-ui/core/TextField'
import { Add } from '@material-ui/icons'
import BuildingForm from 'views/admin/building/BuildingForm'
import CustomPopup from 'components/CustomPopup'
import EventCardForm from 'views/admin/eventCards/EventCardForm'
import { removeUndefinedItemsFromArrayOfString } from 'utils'
import PollAssignment from 'components/PollAssignment/PollAssignment'
import { Box } from '@mui/material'
import TipTapEditor from 'components/TipTapEditor/TipTapEditor'

import ErrorMessage from 'components/ErrorMessage'
import MultiAutocomplete from 'components/MultiAutocomplete'
import { getConferenceSponsors } from 'store/sponsor'
import Autocomplete from '@material-ui/lab/Autocomplete'
import DocumentUpload from 'components/DocumentUpload'
import { FirestoreDatabase, storageRef } from '../../../../../index'
import SpeakerForm from 'views/admin/speakers/SpeakerForm'
import { TagForm } from 'views/admin/conference/components/TagsManagementForm'
import OrganizationForm from 'views/admin/organizations/OrganizationForm'
import ConfirmModal from 'components/ConfirmationModal'

const SubEventForm = () => {
  const classes = useStyles()
  const { eventId, sessionId } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()

  const [confEvents, setConfEvents] = useState([])
  const [confBuildings, setConfBuildings] = useState([])
  const [confSpeakers, setConfSpeakers] = useState([])
  const [confModerators, setConfModerators] = useState([])
  const [confSponsors, setConfSponsors] = useState([])
  const [confCardColors, setConfCardColors] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [loading, setLoading] = useState(false)
  const [openVenueModal, setOpenVenueModal] = useState(false)
  const [openCardColorModal, setOpenCardColorModal] = useState(false)
  const [speakerModalInfo, setSpeakerModalInfo] = useState(null)
  const [openSponsorModal, setOpenSponsorModal] = useState(false)

  const [pendingFormValues, setPendingFormValues] = useState(null)
  const [hasPendingUploads, setHasPendingUploads] = useState(false)
  const [isPendingUploadsModalOpen, setIsPendingUploadsModalOpen] = useState(false)
  const [isVenueTimeUpdateModalOpen, setIsVenueTimeUpdateModalOpen] = useState(false)
  const [venueTimeChangeDetails, setVenueTimeChangeDetails] = useState({
    venue: false,
    time: false
  })

  const [selectedEventId, setSelectedEventId] = useState('')
  const [tagModalOpen, setTagModalOpen] = useState(false)

  const [attachments, setAttachments] = useState([])
  const [loadingAttachments, setLoadingAttachments] = useState(false)
  const [temporaryAttachments, setTemporaryAttachments] = useState([])

  const { user } = useSelector((state) => state.auth)
  const { conference } = useSelector((state) => state.conference)
  const { session } = useSelector((state) => state.session)
  const defaultTimezone = useMemo(() => getDefaultTimezone(conference?.timezone), [conference])

  const eventInfo = useMemo(() => {
    const eventId = selectedEventId || session?.eventId
    return confEvents.find((event) => event.id === eventId)
  }, [selectedEventId, confEvents, sessionId, session])

  const minSessionDate = useMemo(() => {
    const start = eventInfo?.id ? eventInfo?.startDate : conference?.startDate
    return moment(start).tz(defaultTimezone)
  })
  const maxSessionDate = useMemo(() => {
    const end = eventInfo?.id ? eventInfo?.endDate : conference?.endDate
    return moment(end).tz(defaultTimezone)
  }, [eventInfo, conference])

  const startDateLS = localStorage.getItem('subEventStartDate')
    ? parseInt(localStorage.getItem('subEventStartDate'))
    : null
  const endDateLS = localStorage.getItem('subEventEndDate')
    ? parseInt(localStorage.getItem('subEventEndDate'))
    : null

  const initialValues = {
    title: session?.title || '',
    venueId: session?.venueId || '',
    // startDate: startDateLS ? moment(startDateLS).tz(defaultTimezone) : moment().tz(defaultTimezone),
    // endDate: endDateLS ? moment(endDateLS).tz(defaultTimezone) : moment().tz(defaultTimezone),
    startDate: session?.startDate
      ? moment(session?.startDate).tz(defaultTimezone)
      : startDateLS
      ? moment(startDateLS)
      : minSessionDate,
    endDate: session?.endDate
      ? moment(session?.endDate).tz(defaultTimezone)
      : endDateLS
      ? moment(endDateLS)
      : maxSessionDate,
    eventId: eventId || session?.eventId || '',
    inheritVenue: session?.inheritVenue || false,
    inheritTime: session?.inheritTime || false,
    moderators: session?.moderators ?? [],
    speakers: session?.speakers ?? [],
    sponsors: session?.sponsors ?? [],
    tags: session?.tags || [],
    pollIds: session?.pollIds ?? (session?.pollId ? [session.pollId] : []),
    keynotes: session?.keynotes || '',
    cardStyle: session?.cardStyle || '',
    havePolls: session?.havePolls === true ? 'yes' : 'no',
    excludeFromAttendance: session?.excludeFromAttendance ?? false
  }

  const fetchBuildings = async () => {
    const buildings = await getConfBuildings(user?.conferenceId)
    setConfBuildings(buildings)
  }

  const fetchCardColors = async () => {
    const cardColors = await getCardColors(user?.conferenceId)
    setConfCardColors(cardColors)
  }

  const fetchModeratorsAndPresenters = async () => {
    const data = await getModeratorsAndPresenters(user?.conferenceId)
    setConfSpeakers(data.presenters)
    setConfModerators(data.moderators)
  }

  const fetchSponsors = async () => {
    const sponsors = await getConferenceSponsors(user?.conferenceId)
    setConfSponsors(sponsors)
  }

  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true)
      const [events] = await Promise.all([
        getConfEvents(user?.conferenceId),
        fetchBuildings(),
        fetchCardColors(),
        fetchModeratorsAndPresenters(),
        fetchSponsors()
      ])
      const format = conference?.is24hrFormat ? 'MM/DD HH:mm' : 'MM/DD hh:mm A'
      setConfEvents(
        events
          ?.filter((event) => event?.hasSubEvents)
          ?.map((event) => ({
            ...event,
            title: `${event.title} (${moment(event.startDate).format(format)} - ${moment(
              event.endDate
            ).format(format)}) `
          }))
      )
      setIsLoading(false)
    }
    fetch()
  }, [])

  useEffect(() => {
    if (sessionId) {
      dispatch(fetchSessionById(sessionId))
      // Fetch session attachments
      fetchSessionAttachments()
    } else {
      setSelectedEventId(eventId || '')
    }

    return () => {
      dispatch(resetSessionStore())
      setAttachments([])
    }
  }, [sessionId, dispatch, eventId, user?.conferenceId])

  // Fetch session attachments
  const fetchSessionAttachments = async () => {
    try {
      setLoadingAttachments(true)
      if (sessionId && user?.conferenceId) {
        const attachmentsSnapshot = await FirestoreDatabase.collection(Collection.SESSIONS)
          .doc(sessionId)
          .collection(Collection.ATTACHMENTS)
          .get()

        if (!attachmentsSnapshot.empty) {
          const attachmentsList = attachmentsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
          }))
          setAttachments(attachmentsList)
        }
      }
    } catch (error) {
      console.error('Error fetching session attachments:', error)
      toast.error('Could not load attachments. Try again.')
    } finally {
      setLoadingAttachments(false)
    }
  }

  // Handle attachment added
  const handleAttachmentAdded = async (newAttachments) => {
    try {
      if (!sessionId || !user?.conferenceId) return

      const batch = FirestoreDatabase.batch()
      const sessionRef = FirestoreDatabase.collection(Collection.SESSIONS).doc(sessionId)

      for (const attachment of newAttachments) {
        const newAttachmentRef = sessionRef.collection(Collection.ATTACHMENTS).doc()
        batch.set(newAttachmentRef, attachment)
      }

      await batch.commit()
      await fetchSessionAttachments()
    } catch (error) {
      console.error('Error saving attachments:', error)
      toast.error('Could not save attachments. Try again.')
    }
  }

  // Handle attachment deleted
  const handleAttachmentDeleted = async (attachment) => {
    try {
      if (!sessionId) return

      await FirestoreDatabase.collection(Collection.SESSIONS)
        .doc(sessionId)
        .collection(Collection.ATTACHMENTS)
        .doc(attachment.id)
        .delete()

      await fetchSessionAttachments()
    } catch (error) {
      console.error('Error deleting attachment:', error)
      toast.error('Could not delete attachment. Try again.')
    }
  }

  // Handle temporary attachments for new sessions
  const handleTemporaryAttachments = (attachmentsList) => {
    setTemporaryAttachments(attachmentsList)
  }

  // const handleReloadSpeakers = async () => {
  //   setLoadingSpeakers(true)
  //   await dispatch(getSpeakersAssociatedPolls(user?.conferenceId))
  //   setLoadingSpeakers(false)
  // }

  const goBack = () => {
    dispatch(resetSessionStore())
    dispatch(resetEventStore())
    history.goBack()
  }

  const handleInheritVenueChange = (e, setFieldValue, values) => {
    const isChecked = e.target.checked
    setFieldValue('inheritVenue', isChecked)

    if (isChecked && values.eventId) {
      // Find the selected event to get its venue
      const selectedEvent = confEvents.find((event) => event.id === values.eventId)
      if (selectedEvent?.venueId) {
        setFieldValue('venueId', selectedEvent.venueId)
      }
    } else {
      setFieldValue('venueId', '')
    }
  }

  const handleInheritTimeChange = (e, setFieldValue, values) => {
    const isChecked = e.target.checked
    setFieldValue('inheritTime', isChecked)

    if (isChecked && values.eventId) {
      // Find the selected event to get its start and end times
      const selectedEvent = confEvents.find((event) => event.id === values.eventId)
      if (selectedEvent) {
        if (selectedEvent.startDate) {
          setFieldValue('startDate', moment(selectedEvent.startDate).tz(defaultTimezone))
        }
        if (selectedEvent.endDate) {
          setFieldValue('endDate', moment(selectedEvent.endDate).tz(defaultTimezone))
        }
      }
    }
  }

  const handleEventChange = (event, setFieldValue, values) => {
    const eventId = event.target.value
    setFieldValue('eventId', eventId || '')
    setSelectedEventId(eventId)

    const selectedEvent = confEvents.find((event) => event.id === eventId)

    // If inherit venue is checked, set the venue from the selected event
    if (values.inheritVenue && selectedEvent?.venueId) {
      setFieldValue('venueId', selectedEvent.venueId)
    }

    // If inherit time is checked, set the times from the selected event
    if (selectedEvent) {
      if (selectedEvent?.startDate) {
        setFieldValue('startDate', moment(selectedEvent.startDate).tz(defaultTimezone))
      }
      if (selectedEvent?.endDate) {
        setFieldValue('endDate', moment(selectedEvent.endDate).tz(defaultTimezone))
      }
    }
  }

  const handlePendingUploadsConfirm = async (setFieldError) => {
    if (pendingFormValues) {
      // Continue with form submission with the fromConfirmation flag
      await onSubmit(pendingFormValues, { fromConfirmation: true, setFieldError })
    }
    setIsPendingUploadsModalOpen(false)
  }

  const handleClosePendingUploadsModal = () => {
    setIsPendingUploadsModalOpen(false)
    setPendingFormValues(null)
  }

  const handleVenueTimeUpdateConfirm = async (setFieldError) => {
    if (pendingFormValues) {
      // Continue with form submission with the fromConfirmation flag
      await onSubmit(pendingFormValues, { fromConfirmation: true, setFieldError })
    }
    setIsVenueTimeUpdateModalOpen(false)
  }

  const handleCloseVenueTimeUpdateModal = () => {
    setIsVenueTimeUpdateModalOpen(false)
    setVenueTimeChangeDetails({ venue: false, time: false })
    setPendingFormValues(null)
  }

  const onSubmit = async (values, { fromConfirmation = false, setFieldError }) => {
    try {
      // Check if there are temporary attachments that haven't been uploaded yet for new events
      // Or if there are pending uploads for existing events
      if (!fromConfirmation && hasPendingUploads) {
        setPendingFormValues(values)
        setIsPendingUploadsModalOpen(true)
        return
      }

      // Check if venue or time has changed in edit mode (existing session)
      if (
        !fromConfirmation &&
        sessionId &&
        (session?.venueId !== values.venueId ||
          moment(session?.startDate).valueOf() !== moment(values.startDate).utc().valueOf() ||
          moment(session?.endDate).valueOf() !== moment(values.endDate).utc().valueOf())
      ) {
        // Determine what changed
        const venueChanged = session?.venueId !== values.venueId
        const timeChanged =
          moment(session?.startDate).valueOf() !== moment(values.startDate).utc().valueOf() ||
          moment(session?.endDate).valueOf() !== moment(values.endDate).utc().valueOf()

        setPendingFormValues(values)
        setVenueTimeChangeDetails({
          venue: venueChanged,
          time: timeChanged
        })
        setIsVenueTimeUpdateModalOpen(true)
        return
      }

      setLoading(true)
      const sDate =
        typeof values.startDate === 'number' ? values.startDate : values.startDate.valueOf()
      const eDate = typeof values.endDate === 'number' ? values.endDate : values.endDate.valueOf()

      let hasError = false
      if (sDate < eventInfo.startDate) {
        setFieldError('startDate', 'Start time can not be before event start time')
        hasError = true
      }

      if (sDate > eventInfo.endDate) {
        setFieldError('startDate', 'Start time can not be after event end time')
        hasError = true
      }

      if (eDate < eventInfo.startDate) {
        setFieldError('endDate', 'End time can not be before event start time')
        hasError = true
      }

      if (eDate > eventInfo.endDate) {
        setFieldError('endDate', 'End time can not be after event end time')
        hasError = true
      }

      if (hasError) return
      const payload = {
        eventId: values.eventId,
        inheritVenue: values.inheritVenue,
        inheritTime: values.inheritTime,
        title: values.title.trim(),
        venueId: values.venueId.trim(),
        startDate: moment(sDate).seconds(0).milliseconds(0).utc().valueOf(),
        endDate: moment(eDate).seconds(0).milliseconds(0).utc().valueOf(),
        cardStyle: values.cardStyle,
        moderators: removeUndefinedItemsFromArrayOfString(values.moderators),
        speakers: removeUndefinedItemsFromArrayOfString(values.speakers),
        sponsors: removeUndefinedItemsFromArrayOfString(values.sponsors),
        tags: removeUndefinedItemsFromArrayOfString(values.tags) ?? [],
        keynotes: values.keynotes.trim(),
        havePolls: values.havePolls === 'yes',
        pollIds: values.havePolls === 'yes' ? values.pollIds : [],
        excludeFromAttendance: values.excludeFromAttendance ?? false
      }

      const previousPollIds = session?.pollIds ?? (session?.pollId ? [session.pollId] : [])
      const addedPollIds = payload.pollIds.filter((id) => !previousPollIds.includes(id))
      const removedPollIds = previousPollIds.filter((id) => !payload.pollIds.includes(id))

      for (const id of addedPollIds) {
        const isAlreadyUsed = await alreadyUsedPoll(id)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setLoading(false)
          return
        }
      }

      let newSessionId
      if (sessionId) {
        await updateSessionById(sessionId, payload)

        // If venue or time changed and coming from confirmation, update associated talks
        if (fromConfirmation) {
          const venueChanged = session?.venueId !== payload.venueId
          const timeChanged =
            moment(session?.startDate).valueOf() !== payload.startDate ||
            moment(session?.endDate).valueOf() !== payload.endDate

          if (venueChanged || timeChanged) {
            // Get all talks associated with this session
            const talksSnapshot = await FirestoreDatabase.collection(Collection.TALKS)
              .where('sessionId', '==', sessionId)
              .get()

            if (!talksSnapshot.empty) {
              const batch = FirestoreDatabase.batch()
              let updatedTalksCount = 0

              talksSnapshot.docs.forEach((doc) => {
                const talkData = doc.data()
                const updates = {}

                // Update venue if it changed and talk inherits venue from session
                if (venueChanged && talkData.inheritVenue) {
                  updates.venueId = payload.venueId
                }

                // Update time if it changed and talk inherits time from session
                if (timeChanged && talkData.inheritTime) {
                  updates.startDate = payload.startDate
                  updates.endDate = payload.endDate
                }

                if (Object.keys(updates).length > 0) {
                  batch.update(doc.ref, updates)
                  updatedTalksCount++
                }
              })

              await batch.commit()
              if (updatedTalksCount > 0) {
                toast.success(
                  `${updatedTalksCount} associated posters/talks${
                    updatedTalksCount !== 1 ? 's' : ''
                  } have been updated successfully`
                )
              }
            }
          }
        }
      } else {
        newSessionId = await addSession(user?.conferenceId, payload)

        // Upload any temporary attachments for new sessions
        if (temporaryAttachments.length > 0 && newSessionId) {
          const batch = FirestoreDatabase.batch()
          const sessionRef = FirestoreDatabase.collection('sessions').doc(newSessionId)

          for (const attachment of temporaryAttachments) {
            try {
              // Upload file to Firebase Storage
              const fileRef = storageRef.child(attachment.path)
              await fileRef.put(attachment.file)
              const downloadUrl = await fileRef.getDownloadURL()

              // Create attachment record without the file object
              const { file, ...attachmentData } = attachment
              const newAttachmentRef = sessionRef.collection('attachments').doc()
              batch.set(newAttachmentRef, {
                ...attachmentData,
                downloadUrl
              })
            } catch (error) {
              console.error(`Error uploading file ${attachment.fileName}:`, error)
              toast.error(`Could not upload ${attachment.fileName}.`)
            }
          }

          await batch.commit()
        }
      }
      // detach polls that were removed, and attach newly assigned polls to this sub event
      await Promise.all(
        removedPollIds.map((id) =>
          pollAttachOrDetach(id, { eventId: null, sessionId: null, talkId: null, alreadyUsed: false })
        )
      )
      await Promise.all(
        addedPollIds.map((id) =>
          pollAttachOrDetach(id, {
            eventId: eventInfo?.id,
            sessionId: newSessionId ? newSessionId : sessionId,
            talkId: '',
            alreadyUsed: true
          })
        )
      )
      setLoading(false)
      toast.success(
        sessionId
          ? 'Sub Event updated.'
          : 'Sub Event created.'
      )
      if (values.inheritTime) {
        localStorage.setItem('subEventStartDate', payload.startDate)
        localStorage.setItem('subEventEndDate', payload.endDate)
      } else {
        localStorage.setItem('subEventStartDate', payload.endDate)
        localStorage.setItem(
          'subEventEndDate',
          payload.endDate + (payload.endDate - payload.startDate)
        )
      }
      goBack()
    } catch (err) {
      toast.error(err?.message)
    } finally {
      setLoading(false)
    }
  }

  if (isLoading) {
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          justifyContent: 'center',
          marginTop: '4rem'
        }}>
        <CircularProgress />
        Loading, please wait...
      </Box>
    )
  }

  return (
    <CustomBox>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={sessionFromSchema}>
        {({ values, setFieldError, touched, errors, setFieldValue, setFieldTouched }) => {
          const overlappingIds = (values.moderators || []).filter((id) =>
            (values.speakers || []).includes(id)
          )
          const overlappingNames = overlappingIds
            .map((id) => {
              const person = [...confModerators, ...confSpeakers].find((p) => p.id === id)
              return person?.fullName || id
            })
            .join(', ')
          const rolesOverlapWarning = overlappingNames
            ? `${overlappingNames} ${
                overlappingIds.length > 1 ? 'are' : 'is'
              } added as both a moderator and a speaker.`
            : ''

          return (
          <Form>
            <ViewHeader title={sessionId ? 'Edit Sub Event' : 'Create Sub Event'}>
              <Box style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <Button variant="outlined" onClick={goBack}>
                  Back
                </Button>
                {conference?.enableAcademics && sessionId && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      history.push(
                        `/admin/schedule/events/${
                          eventId || session?.eventId
                        }/sub-events/${sessionId}/talks`
                      )
                    }>
                    View Talks/Posters
                  </Button>
                )}
                <ProgressButton
                  type="submit"
                  label="Save"
                  inProgress={loading}
                  disabled={loading}
                />
              </Box>
            </ViewHeader>
            <Grid container spacing={3}>
              <Grid
                container
                spacing={3}
                style={{ display: 'flex', alignItems: 'end', padding: '0px 10px' }}>
                <Grid item xs={12} md={8}>
                  <SingleAutocomplete
                    label="Event"
                    options={confEvents || []}
                    displayField="title"
                    value={values.eventId}
                    onChange={(eventId) =>
                      handleEventChange({ target: { value: eventId } }, setFieldValue, values)
                    }
                    error={touched.eventId && errors.eventId ? errors.eventId : ''}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.inheritVenue}
                        onChange={(e) => handleInheritVenueChange(e, setFieldValue, values)}
                        name="inheritVenue"
                        color="primary"
                      />
                    }
                    label="Inherit Building from Parent Event?"
                  />

                  <TextField
                    select
                    fullWidth
                    label="Building"
                    variant="outlined"
                    disabled={values.inheritVenue}
                    error={Boolean(touched.venueId && errors.venueId)}
                    value={values.venueId}
                    onChange={(event) =>
                      event.target.value && setFieldValue('venueId', event.target.value)
                    }
                    helperText={touched.venueId && errors.venueId ? errors.venueId : null}>
                    <MenuItem
                      className={classes.stickyMenuItem}
                      onClick={() => setOpenVenueModal(true)}
                      disabled={values.inheritVenue}>
                      <Typography className={classes.buttonItem}>
                        <Add />
                        Create building
                      </Typography>
                    </MenuItem>
                    <Divider />
                    {confBuildings?.map((building) => (
                      <MenuItem value={building.id} key={building.id}>
                        <Typography>
                          {building?.buildingText?.length > 50
                            ? `${building?.buildingText.substring(0, 50)}...`
                            : building?.buildingText}
                        </Typography>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
              <Grid item xs={12} md={8} style={{ marginTop: 10 }}>
                <CustomTextField
                  label="Sub Event Title"
                  name="title"
                  type="text"
                  values={values.title}
                />
              </Grid>
              <Grid item xs={12} lg={4} style={{ marginTop: 10 }}>
                <TextField
                  select
                  fullWidth
                  label="Card Color"
                  variant="outlined"
                  error={Boolean(touched.cardStyle && errors.cardStyle)}
                  value={values.cardStyle}
                  onChange={(event) =>
                    event.target.value && setFieldValue('cardStyle', event.target.value)
                  }
                  helperText={touched.cardStyle && errors.cardStyle ? errors.cardStyle : null}>
                  <MenuItem
                    className={classes.stickyMenuItem}
                    onClick={() => setOpenCardColorModal(true)}>
                    <Typography className={classes.buttonItem}>
                      <Add />
                      Create card color
                    </Typography>
                  </MenuItem>
                  <Divider />
                  {confCardColors?.map((cardColor) => (
                    <MenuItem value={cardColor.id} key={cardColor.id}>
                      <Box className={classes.menuItem}>
                        <Box
                          sx={{
                            width: '18px',
                            height: '18px',
                            borderRadius: '4px',
                            backgroundColor: cardColor.bgColor ?? ''
                          }}></Box>
                        <Typography>{cardColor.type}</Typography>
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.inheritTime}
                      onChange={(e) => handleInheritTimeChange(e, setFieldValue, values)}
                      name="inheritTime"
                      color="primary"
                    />
                  }
                  label="Inherit Time from Parent Event?"
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <CustomDateTimePicker
                  mode="datetime"
                  value={values.startDate}
                  label="Start Date & Time"
                  name="startDate"
                  is24hrFormat={conference?.is24hrFormat || false}
                  minDateTime={minSessionDate}
                  maxDateTime={maxSessionDate}
                  disabled={values.inheritTime}
                  onChange={(value) => {
                    setFieldValue('startDate', value)
                    if (!sessionId) {
                      setFieldValue('endDate', value)
                    }
                  }}
                  error={!!(touched.startDate && errors.startDate)}
                  helperText={touched.startDate && errors.startDate ? errors.startDate : ''}
                  onBlur={() => setFieldTouched('startDate', true)}
                />
                <CustomDateTimePicker
                  mode="datetime"
                  value={values.endDate}
                  label="End Date & Time"
                  name="endDate"
                  is24hrFormat={conference?.is24hrFormat || false}
                  minDateTime={minSessionDate}
                  maxDateTime={maxSessionDate}
                  disabled={values.inheritTime}
                  onChange={(value) => setFieldValue('endDate', value)}
                  error={!!(touched.endDate && errors.endDate)}
                  helperText={touched.endDate && errors.endDate ? errors.endDate : ''}
                  onBlur={() => setFieldTouched('endDate', true)}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <MultiAutocomplete
                  label="Moderators"
                  options={confModerators || []}
                  displayField="fullName"
                  value={values.moderators}
                  error={errors.moderators}
                  warningText={rolesOverlapWarning}
                  onChange={(value) => setFieldValue('moderators', value)}
                  createNewOption={true}
                  createNewLabel="Create Moderator"
                  onCreateNew={() =>
                    setSpeakerModalInfo({
                      open: true,
                      role: SpeakerRoles.MODERATOR
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <MultiAutocomplete
                  label="Speakers"
                  options={confSpeakers || []}
                  displayField="fullName"
                  value={values.speakers}
                  error={errors.speakers}
                  warningText={rolesOverlapWarning}
                  onChange={(value) => setFieldValue('speakers', value)}
                  createNewOption={true}
                  createNewLabel="Create Speaker"
                  onCreateNew={() =>
                    setSpeakerModalInfo({
                      open: true,
                      role: SpeakerRoles.PRESENTER
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <MultiAutocomplete
                  label="Sponsors"
                  options={confSponsors}
                  displayField="organization"
                  value={values.sponsors}
                  error={errors.sponsors}
                  onChange={(value) => setFieldValue('sponsors', value)}
                  createNewOption={true}
                  createNewLabel="Create Sponsor"
                  onCreateNew={() => setOpenSponsorModal(true)}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.excludeFromAttendance}
                      onChange={(e) => setFieldValue('excludeFromAttendance', e.target.checked)}
                      name="excludeFromAttendance"
                      color="primary"
                    />
                  }
                  label="Exclude from Attendance"
                />
                <FormHelperText>
                  {values.excludeFromAttendance
                    ? 'Attendance cannot be marked for this sub event.'
                    : 'Check this to hide this sub event from the attendance selection list'}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={[
                    ...(conference?.tags || []),
                    { name: 'Create new tag', isOption: false }
                  ]}
                  value={values.tags
                    .map((itemId) => conference?.tags?.find((item) => item['id'] === itemId))
                    .filter(Boolean)}
                  error={errors.tags}
                  onChange={(_e, value) => {
                    if (
                      Array.isArray(value) &&
                      value.length &&
                      value[value.length - 1].isOption === false
                    ) {
                      setTagModalOpen(true)
                      return
                    }
                    setFieldValue(
                      'tags',
                      value?.map((item) => item['id'])
                    )
                  }}
                  getOptionLabel={(option) => option?.name}
                  renderOption={(option) => {
                    return option.isOption === false ? (
                      <li className={classes.nonSelectedMenu}>
                        <Typography className={classes.buttonItem}>
                          <Add />
                          <Typography>{option.name}</Typography>
                        </Typography>
                      </li>
                    ) : (
                      <Box
                        component="li"
                        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Chip
                          label={option.name}
                          size="small"
                          style={{
                            backgroundColor: option.color || '#f1f1f1',
                            color: getContrastColor(option.color) || '#333',
                            borderRadius: '10px',
                            fontSize: '14px',
                            fontWeight: '500',
                            padding: '2px 4px',
                            height: '24px'
                          }}
                        />
                      </Box>
                    )
                  }}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.name}
                        size="small"
                        style={{
                          backgroundColor: option.color || '#f1f1f1',
                          color: getContrastColor(option.color) || '#333',
                          marginRight: '4px',
                          fontSize: '14px',
                          borderRadius: '10px',
                          fontWeight: '500',
                          padding: '2px 4px',
                          height: '24px'
                        }}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={touched.tags && errors.tags}
                      variant="outlined"
                      label="Tags"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                  <label className={classes.label}>Keynotes</label>
                  <TipTapEditor
                    hasPlaceholders={false}
                    value={values.keynotes}
                    onChange={(value) => setFieldValue('keynotes', value)}
                    placeholder="Write keynotes here..."
                  />
                  <ErrorMessage message={touched?.keynotes && errors?.keynotes} />
                </Box>
              </Grid>

              {/* Document Attachments */}
              <Grid item xs={12}>
                <DocumentUpload
                  title="Sub Event Documents"
                  subTitle="Attach documents related to this sub event. Allowed formats: PDF, DOCX, XLSX, PPTX, TXT (Max size: 10MB)"
                  attachmentType="sub-events"
                  conferenceId={user?.conferenceId}
                  entityId={sessionId}
                  attachments={attachments}
                  onAttachmentAdded={handleAttachmentAdded}
                  onAttachmentDeleted={handleAttachmentDeleted}
                  onTemporaryAttachments={handleTemporaryAttachments}
                  onPendingUploadsChange={setHasPendingUploads}
                />
              </Grid>

              {conference?.havePolls && (
                <>
                  <Grid item xs={12}>
                    <Box className={classes.radioGroup}>
                      <Typography className={classes.radioLabel}>
                        Do you want to associate a poll with this Sub Event?
                      </Typography>
                      <RadioGroup
                        row
                        value={values.havePolls}
                        onChange={(e) => {
                          // Don't eagerly clear pollIds here: PollAssignment only renders
                          // while havePolls is 'yes', so toggling to 'no' unmounts it and
                          // toggling back remounts it fresh — clearing pollIds first would
                          // make it think this entity never had any polls, disabling every
                          // still-genuinely-assigned poll as "assigned elsewhere" before the
                          // admin even saves. onSubmit already coerces pollIds to [] when
                          // havePolls is 'no', so nothing here needs to force it early.
                          setFieldValue('havePolls', e.target.value)
                        }}>
                        <FormControlLabel
                          control={<Radio size="small" />}
                          label={<Typography variant="body2">Yes</Typography>}
                          value="yes"
                        />
                        <FormControlLabel
                          control={<Radio size="small" />}
                          label={<Typography variant="body2">No</Typography>}
                          value="no"
                        />
                      </RadioGroup>
                    </Box>
                  </Grid>
                  {values.havePolls === 'yes' && (
                    <Grid item xs={12}>
                      <PollAssignment
                        conferenceId={user?.conferenceId}
                        speakerIds={values.speakers}
                        confSpeakers={confSpeakers}
                        value={values.pollIds}
                        persistedPollIds={
                          session?.pollIds ?? (session?.pollId ? [session.pollId] : [])
                        }
                        onChange={(pollIds) => setFieldValue('pollIds', pollIds)}
                        onSpeakerAdded={(speakerId) =>
                          setFieldValue('speakers', [...values.speakers, speakerId])
                        }
                        error={touched.pollIds && errors.pollIds}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
            <Grid container spacing={2} className={classes.actionButtons}>
              <Grid item>
                <Button disabled={loading} size="large" onClick={goBack}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <ProgressButton
                  type="submit"
                  label="Save"
                  inProgress={loading}
                  disabled={loading}
                />
              </Grid>
            </Grid>

            <ConfirmModal
              dialogTitle="Pending File Uploads"
              dialogText="You have selected files that haven’t been uploaded. If you save now without clicking 'Upload All,' these files will not be uploaded. Do you want to continue?"
              open={isPendingUploadsModalOpen}
              closeModal={handleClosePendingUploadsModal}
              handleConfirm={() => handlePendingUploadsConfirm(setFieldError)}
              inProgress={loading}
            />

            <ConfirmModal
              dialogTitle="Update Building/Time Warning"
              dialogText={
                venueTimeChangeDetails.venue && venueTimeChangeDetails.time
                  ? 'Changing the venue and date/time will update both in posters/talks that inherit them from this sub-event.'
                  : venueTimeChangeDetails.venue
                  ? 'Changing the venue will update it in posters/talks that inherit the venue from this sub-event.'
                  : 'Changing the date/time will update the start and end date/time in posters/talks that inherit time from this sub-event.'
              }
              dialogText2="Do you want to continue?"
              open={isVenueTimeUpdateModalOpen}
              closeModal={handleCloseVenueTimeUpdateModal}
              handleConfirm={() => handleVenueTimeUpdateConfirm(setFieldError)}
              inProgress={loading}
            />

            <CustomPopup
              title="Create building"
              maxWidth="lg"
              open={openVenueModal}
              onClose={() => setOpenVenueModal(false)}>
              <BuildingForm
                displayContext="modal"
                onCloseModal={() => setOpenVenueModal(false)}
                onSuccess={async (venueId) => {
                  await fetchBuildings()
                  setOpenVenueModal(false)
                  setFieldValue('venueId', venueId)
                }}
              />
            </CustomPopup>
            <CustomPopup
              title="Create card color"
              maxWidth="lg"
              open={openCardColorModal}
              onClose={() => setOpenCardColorModal(false)}>
              <EventCardForm
                displayContext="modal"
                onCloseModal={() => setOpenCardColorModal(false)}
                onSuccess={async (cardColorId) => {
                  await fetchCardColors()
                  setOpenCardColorModal(false)
                  setFieldValue('cardStyle', cardColorId)
                }}
              />
            </CustomPopup>
            <CustomPopup
              title="Create Tag"
              maxWidth="md"
              open={tagModalOpen}
              onClose={() => setTagModalOpen(false)}>
              <TagForm
                onCancel={() => setTagModalOpen(false)}
                conference={conference}
                onSuccess={(tagId) => {
                  setTagModalOpen(false)
                  setFieldValue('tags', [...values.tags, tagId])
                }}
              />
            </CustomPopup>
            <CustomPopup
              title={`Create ${
                speakerModalInfo?.role === SpeakerRoles.PRESENTER ? 'Speaker' : 'Moderator'
              }`}
              maxWidth="lg"
              open={speakerModalInfo?.open || false}
              onClose={() => setSpeakerModalInfo(null)}>
              <SpeakerForm
                displayContext="modal"
                preDefinedRole={speakerModalInfo?.role}
                onCloseModal={() => setSpeakerModalInfo(null)}
                onSuccess={async (id) => {
                  await fetchModeratorsAndPresenters()
                  setSpeakerModalInfo(null)
                  if (speakerModalInfo?.role === SpeakerRoles.PRESENTER) {
                    setFieldValue('speakers', [...values.speakers, id])
                  } else {
                    setFieldValue('moderators', [...values.moderators, id])
                  }
                }}
              />
            </CustomPopup>

            <CustomPopup
              title="Create sponsor"
              maxWidth="lg"
              open={openSponsorModal}
              onClose={() => setOpenSponsorModal(false)}>
              <OrganizationForm
                displayContext="modal"
                onCloseModal={() => setOpenSponsorModal(false)}
                onSuccess={async (sponsorId) => {
                  await fetchSponsors()
                  setOpenSponsorModal(false)
                  setFieldValue(
                    'sponsors',
                    values?.sponsors?.length > 0 ? [...values.sponsors, sponsorId] : [sponsorId]
                  )
                }}
              />
            </CustomPopup>
          </Form>
          )
        }}
      </Formik>
    </CustomBox>
  )
}
export default SubEventForm

const useStyles = makeStyles({
  label: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    color: '#606060'
  },
  chipLabel: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 'bold'
  },
  selectSpeakerMenu: {
    '& .MuiOutlinedInput-root': {
      '& .MuiSelect-outlined.MuiSelect-outlined': {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }
    }
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  chip: {
    background: '#c62828',
    color: '#FFFFFF'
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioLabel: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2f2f2f'
  },
  actionButtons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'end'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  buttonItem: {
    color: colors.indigo,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem'
  },
  stickyMenuItem: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: '#fff'
  },
  nonSelectedMenu: {
    backgroundColor: 'transparent !important'
  }
})
